import React, {useEffect, useState} from 'react';
import { Button } from 'react-bootstrap';
import WorkOrderDatatable from './WorkOrderDatatable';
import WorkOrderModal from './WorkOrderModal';




const DocumentWorkOrderListTab = (props) => {

    
  const [show , setShow]= useState( false );
  const [recordId, setRecordId ] = useState();    
  const [checkTime, setCheckTime] = useState(null);
  const [showAndRecordId, setShowAndRecordId] = useState(
    {
      show: false,
      recordId: ''
    }
  );

  const handleCallback = (id) => {      
    if(id!==''){
      props.parentCallback(id,'DETAIL');
    }else{
           
        modalCallback(true,id);
      

    }
  };

  const modalCallback = (show,id) => {             
      setRecordId(id);  
      setShow(show);          
   
  }



  useEffect(() => {      
    setCheckTime(Date.now());
  }, [props.isActive])


  return (
      <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
      
        <WorkOrderDatatable      
          parentCallback={handleCallback}  
          modalCallback={modalCallback}  
          modalShow={show}    
          checkTime={checkTime}     
          hideEdit={false}                             
        />
       
        <WorkOrderModal 
          modal={show}
          parentCallback={setShow}
          selectedRecord={recordId}                      
        />
       
        <Button
          bsStyle="primary"
        //  bsSize="large"
          className="ml-3 mt-3"
          onClick={() => handleCallback('')} 
        >
          <i className="fas fa-plus"></i>
        </Button>
      </div>
  );
};

export default DocumentWorkOrderListTab;